import useWindowSize from "./useWindowSize";

function Footer() {
    // <div id="shareButtons"></div>
        // const {width, height} = useWindowSize();
        const {width} = useWindowSize();
        // console.log("width", width, "height", height);
        if(width > 560){
            return (
                <footer>
                    <div id="about">
                        <p><b>“I am the Lord your God who brought you out of Egypt, out of the house of bondage.”</b></p>
                    </div>
                    <div id="shareButtons"></div>
                 </footer>
            )
        } else {
            return (
                <footer>
                <div id="about">
                    <p><b>“I am the Lord your God you brought you out of Egypt,</b></p>
                    <p><b>out of the house of bondage.”</b></p>
                </div>
                <div id="shareButtons"></div>
                </footer>
            );
        }
  };
  export default Footer;